<template lang="pug">
	.creative-request(v-if="showed")
		.card
			.card-header
				span Request custom playable ad development
			.card-body.collapse.show
				.message
					| {{Metadata.Config['dashboard-domain-title']}} team can develop any custom playable ad for your game, app or real world product. Please contact&nbsp;
					a(:href="'mailto:' + Metadata.Config['request-playable-email']") {{Metadata.Config['request-playable-email']}}
					| &nbsp;and provide any available information about your needs.
			.card-body.collapse.show
				.form-horizontal
					.form-actions
						button.btn.btn-dark(type="button" v-on:click="close()") Close
</template>

<script>

	import Screen 				from './../../mixins/screen'

	export default {
		name: "PlayableCreateRequest",
		mixins: [Screen],
		screen: {
			events: {
				"Show PlayableCreateRequest": function() {

					this.showed = true;

				}
			}
		},
		data() {
			return {
				showed: false
			};
		},
		methods: {
			close() {

				this.hide();

			}
		}
	}
</script>

<style lang="sass">

	.creative-request
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)

		.card
			width: 450px
			position: absolute
			left: 0
			right: 0
			top: 0
			bottom: 0
			margin: auto
			display: flex
			height: 200px
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

			.btn-ghost-dark, .btn-dark
				float: right
				color: #fff

			.form-actions
				position: absolute
				right: 19px
				bottom: 20px
				width: calc(100% - 40px)

</style>

